module.exports = __webpack_public_path__ + "media/images/client_certificate_selection/certificates_in_chrome-4c4101de79fe598afd0c842b3ebb83c7.png";